/* unplugin-vue-components disabled */import { render } from "./ConfigTable.vue?vue&type=template&id=6906641a&scoped=true"
import script from "./ConfigTable.vue?vue&type=script&lang=js"
export * from "./ConfigTable.vue?vue&type=script&lang=js"

import "./ConfigTable.vue?vue&type=style&index=0&id=6906641a&lang=scss&scoped=true"
import "./ConfigTable.vue?vue&type=style&index=1&id=6906641a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6906641a"]])

export default __exports__